import { LazyLoad } from 'app/utils';

export const PerformanceListPage = LazyLoad(
  () => import('./index'),
  (module) => module.PerformanceListPage,
);
